import * as React from 'react';
import { ThemeProvider } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment, { Moment } from 'moment';
import {cStylesDatepicker, yellowTheme} from '../../CustomModalStyles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { enUS, fiFI } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Modal from "react-modal";
import {translateService} from "../../services/TranslateService";

interface BirthdayModalPickerProps {
    open: boolean;
    onClose: () => void;
    onContinue: (date: string) => void;
    currentValue: string;
    language: string;
}

function formatDateString(str: string): string {
    if (/^\d{8}$/.test(str)) {
        // Insert dash after 2nd and 4th character
        return str.slice(0, 2) + '-' + str.slice(2, 4) + '-' + str.slice(4);
    }
    return str;
}

export const BirthdayModalPicker:
    React.FC<BirthdayModalPickerProps> = ({open, onClose, onContinue, currentValue, language}) => {
    let currentFormatted = formatDateString(currentValue);
    const [datePickerOpen, setDatePickerOpen] = React.useState(true);
    const [selectedDate, setSelectedDate] = React.useState<Moment | null>(currentFormatted ? moment(currentFormatted, 'DD-MM-YYYY') : null);
    const todayMinus18 = moment().subtract(18, 'year').startOf('day');
    const initialDate = selectedDate ? moment(selectedDate, 'DD-MM-YYYY') : todayMinus18;

    React.useEffect(() => {
        setSelectedDate(currentFormatted ? moment(currentFormatted, 'DD-MM-YYYY') : null);
    }, [currentFormatted, open]);

    return (
        <Modal isOpen={open} style={cStylesDatepicker}>
            <div style={{width: '100%', textAlign: 'center'}}>
                <ThemeProvider theme={yellowTheme}>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={language}
                                          localeText={language === 'en' ? enUS.components.MuiLocalizationProvider.defaultProps.localeText : fiFI.components.MuiLocalizationProvider.defaultProps.localeText}>
                        <button className='btn modal-close-datepicker float-right' onClick={onClose}>x</button>
                        <div onClick={() => {if (!datePickerOpen) setDatePickerOpen(true)}} >
                            <DatePicker
                                label={translateService.translate("vehicleSearch1.birthDate")}
                                open={datePickerOpen}
                                value={initialDate}
                                onChange={setSelectedDate}
                                format='DD/MM/YYYY'
                                maxDate={todayMinus18}
                                closeOnSelect={false}
                                sx={{
                                    width: '100%',
                                    mb: 2,
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '5px',
                                        backgroundColor: '#fff',
                                        borderColor: 'gray',
                                        height: '50px',
                                        fontWeight: 600,
                                    },
                                }}
                                onAccept={() => {
                                    setDatePickerOpen(false);
                                }}
                                onOpen={() => {setDatePickerOpen(true)}}
                                onClose={() => {
                                    setDatePickerOpen(false);
                                }}
                                slotProps={{
                                    field: {readOnly: true},
                                    actionBar: {
                                        actions: ["cancel", "accept"],
                                    },
                                    inputAdornment: {
                                        disablePointerEvents: true
                                    },
                                    popper: {
                                        popperOptions: {
                                            placement: "bottom"
                                        }
                                    }
                                }}
                            />
                        </div>
                        <button className='btn btn-primary btn-cta m-auto' onClick={() => {
                            if (selectedDate) onContinue(selectedDate.format('DDMMYYYY'));
                            else onContinue('');
                        }}>{translateService.translate('vehicleSearch1.confirmBirthdate')}</button>
                    </LocalizationProvider>
                </ThemeProvider>
            </div>
        </Modal>
    );
};
